import type { FC } from 'react';

import { LoadingPage } from '#packages/web/layouts/page/templates';

export const InitPage: FC = () => <LoadingPage />;
